import React from 'react'
import { TextNpsQuestion } from '../types/nps.types'

interface Props {
    question: TextNpsQuestion
    value: string | undefined
    onChange: (value: string) => void
    error?: string
}

const NpsText: React.FC<Props> = ({ question, value, onChange, error }) => {
    const { id, question: label, maxLength, required } = question
    const inputId = `nps-text-${id}`
    const errorId = `${inputId}-error`
    const current = value ?? ''
    const showCounter = typeof maxLength === 'number'

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const next = event.target.value
        if (typeof maxLength === 'number' && next.length > maxLength) {
            onChange(next.slice(0, maxLength))
        } else {
            onChange(next)
        }
    }

    return (
        <div className="flex flex-col gap-2">
            <label htmlFor={inputId} className="flex items-start gap-1 text-[0.75rem] font-semibold text-gray-800">
                <span>{label}</span>
                {required && (
                    <span aria-hidden className="text-red-500">
                        *
                    </span>
                )}
            </label>

            <textarea
                id={inputId}
                value={current}
                onChange={handleChange}
                maxLength={maxLength}
                aria-required={required || undefined}
                aria-invalid={error ? true : undefined}
                aria-describedby={error ? errorId : undefined}
                rows={3}
                data-testid={`nps-text-${id}`}
                className={`w-full text-[0.75rem] leading-[1.3] border rounded-[0.267rem] px-2 py-2 focus:outline-none focus:ring-2 focus:ring-primary/40 ${error ? 'border-2 border-red-500' : 'border border-gray-300'}`}
            />

            {showCounter && (
                <div className="flex justify-end -mt-1">
                    <span className={`text-[0.583rem] px-2 py-0.5 rounded-sm ${current.length === maxLength ? 'text-red-600 bg-red-100' : 'text-slate-600 bg-slate-100'}`}>
                        {current.length}/{maxLength}
                    </span>
                </div>
            )}

            {error && (
                <p id={errorId} role="alert" className="text-error text-[0.583rem]">
                    {error}
                </p>
            )}
        </div>
    )
}

export default NpsText
